import { ReactNode } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import IconComponent from '../IconComponent/IconComponent';

interface ResponsiveFiltersHeaderProps extends BoxProps {
  leftContent: ReactNode;
  rightContent?: ReactNode;
  onClearFilters: () => void;
  showClearFilters: boolean
}

export function ResponsiveFiltersHeader({
  leftContent,
  rightContent,
  onClearFilters,
  showClearFilters,
  ...boxProps
}: ResponsiveFiltersHeaderProps) {
  return (
    <Box
      display="grid"
      gridTemplateColumns={{ base: '1fr', md: rightContent ? '1fr auto' : '1fr' }}
      gap={4}
      alignItems="start"
      mb={4}
      width="100%"
      zIndex={50}
      {...boxProps}>
      {/* Left side: filters, buttons, inputs */}
      <Box display="flex" flexWrap="wrap" gap={3}>
        {leftContent}

        {showClearFilters && <Box display="flex" justifyContent="flex-end">
          <button
            type="button"
            onClick={() => {
              onClearFilters()
            }}
            className="flex items-center gap-spacing-md font-semibold text-xs text-grayWarm-950">
            <IconComponent iconName="xClose" />
            <p>Wyczyść filtry</p>
          </button>
        </Box>
        }
      </Box>

      {/* Right side: date picker or compact filter */}
      {rightContent && (
        <Box display="flex" justifyContent="flex-end">
          {rightContent}
        </Box>
      )}
    </Box>
  );
}
